import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastService } from 'app/services/toast.service';
import { from, of, pipe } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import * as Action from './actions'
import { Router } from '@angular/router';

import { NotificationService } from 'app/services/dal/notification.service';
import { markAllTapAsRead, loadReadItemsFromSelectedBarId, loadUnreadItemsFromSelectedBarId, deleteAllTapNotificationsSuccess, loadCountAllNotificationsFromCurrentBarId, markAllAsRead } from './actions';
import { environment } from 'environments/environment';
import { Store } from '@ngrx/store';
import * as fromBar from 'app/state/bar/reducer';
import { trackLoading } from '../effect-helpers';



@Injectable()
export class Effects
// implements OnInitEffects
{



  // ngrxOnInitEffects() {
  //   return Action.loadItemsFromInitEffect;
  // }



  constructor(
    private store: Store,
    private router: Router,
    private actions$: Actions,
    private notificationService: NotificationService,
    private toastService: ToastService) { }

  // loadItems$ = createEffect(() => {
  //   return this.actions$
  //     .pipe(
  //       ofType(
  //         Action.loadItems,
  //         Action.loadItemsFromInitEffect
  //       ),
  //       mergeMap((action) => this.notificationService.getItemsWithTake(action.barId, environment.notificationsCount)
  //         .pipe(
  //           map(items => Action.loadItemsSuccess({ items })),
  //           catchError(error => {
  //             console.error('error', error);

  //             return of(Action.loadItemsFailure({ error }))
  //           }
  //           )
  //         )
  //       )
  //     );
  // });

  loadReadItems$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(
          Action.loadReadItems,
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'notifications_read',
            action.barId,
            this.notificationService.getReadItemsWithTake(action.barId, environment.notificationsCount).pipe(
              map(items => Action.loadItemsSuccess({ items })),
              catchError(error => {
                console.error('error', error);
                return of(Action.loadItemsFailure({ error }))
              })
            )
          )
        )
      );
  });

  loadUnreadItems$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(
          Action.loadUnreadItems
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'notifications_unread',
            action.barId,
            this.notificationService.getUnreadItemsWithTake(action.barId, environment.notificationsCount).pipe(
              map(items => Action.loadUnreadItemsSuccess({ barId: action.barId, items })),
              catchError(error => {
                console.error('error', error);
                return of(Action.loadItemsFailure({ error }))
              })
            )
          )
        )
      );
  });


  loadReadItemsFromSelectedBarId$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadReadItemsFromSelectedBarId),
        withLatestFrom(this.store.select(fromBar.selectBarId)),
        mergeMap(([action, barId]) => {
          if (!barId) {
            return of(Action.loadItemsFailure({ error: 'No barId available' }));
          }
          return this.notificationService.getReadItemsWithTake(barId, environment.notificationsCount)
            .pipe(
              map(items => Action.loadItemsSuccess({ items })),
              catchError(error => {
                console.error('error', error);
                return of(Action.loadItemsFailure({ error }));
              })
            );
        })
      );
  });

  loadUnreadItemsFromSelectedBarId$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadUnreadItemsFromSelectedBarId),
        withLatestFrom(this.store.select(fromBar.selectBarId)),
        mergeMap(([action, barId]) => {
          if (!barId) {
            return of(Action.loadItemsFailure({ error: 'No barId available' }));
          }
          return this.notificationService.getUnreadItemsWithTake(barId, environment.notificationsCount)
            .pipe(
              map(items => Action.loadUnreadItemsSuccess({ barId, items })),
              catchError(error => {
                console.error('error', error);
                return of(Action.loadItemsFailure({ error }));
              })
            );
        })
      );
  });

  loadUnreadItemsAfter$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(
          Action.loadUnreadItemsAfter,
        ),
        mergeMap((action) => from(this.notificationService.getUnreadItemsWithTakeFrom(action.barId, 15, action.startAfter))
          .pipe(
            map(items => Action.loadItemsAfterSuccess({ items })),
            catchError(error => {
              console.error('error', error);

              return of(Action.loadItemsFailure({ error }))
            }
            )
          )
        )
      );
  });

  loadReadItemsAfter$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(
          Action.loadReadItemsAfter,
        ),
        mergeMap((action) => from(this.notificationService.getReadItemsWithTakeFrom(action.barId, 15, action.startAfter))
          .pipe(
            map(items => Action.loadItemsAfterSuccess({ items })),
            catchError(error => {
              console.error('error', error);

              return of(Action.loadItemsFailure({ error }))
            }
            )
          )
        )
      );
  });

  loadAllItemsAfter$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(
          Action.loadAllItemsAfter,
        ),
        mergeMap((action) => from(this.notificationService.getAllItemsWithTakeFrom(action.barId, 15, action.startAfter))
          .pipe(
            map(items => Action.loadItemsAfterSuccess({ items })),
            catchError(error => {
              console.error('error', error);

              return of(Action.loadItemsFailure({ error }))
            }
            )
          )
        )
      );
  });

  setItemFromListPage$ = createEffect(
    () => {
      return this.actions$
        .pipe(
          ofType(Action.setItemFromListPage),
          tap((action) => {
            this.router.navigate(['/notifications/details', action.id]);
          }),
        )
    },
    { dispatch: false }
  );


  update$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.updateItem),
        mergeMap((action) => from(this.notificationService.update(action.item))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.updateItemSuccess({ item: action.item });
            }),
            catchError(error => of(Action.updateItemFailure({ error })))
          )
        )
      );
  });

  //#region Count Notifications
  countAllNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountAllNotifications),
        mergeMap((action) => from(this.notificationService.countAllNotifications(action.barId))
          .pipe(
            map((count) => Action.loadCountAllNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountAllNotificationsFailure({ error })))
          )
        )
      );
  });

  loadCountAllNotificationsFromCurrentBarId$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountAllNotificationsFromCurrentBarId),
        withLatestFrom(this.store.select(fromBar.selectBarId)),
        mergeMap(([action, barId]) => from(this.notificationService.countAllNotifications(barId ?? ''))
          .pipe(
            map((count) => Action.loadCountAllNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountAllNotificationsFailure({ error })))
          )
        )
      );
  });

  countReadlNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountReadNotifications),
        mergeMap((action) => from(this.notificationService.countReadNotifications(action.barId))
          .pipe(
            map((count) => Action.loadCountReadNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountReadNotificationsFailure({ error })))
          )
        )
      );
  });

  countReadlNotificationsFromCurrentBarId$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountReadNotificationsFromCurrentBarId),
        withLatestFrom(this.store.select(fromBar.selectBarId)),
        mergeMap(([action, barId]) => from(this.notificationService.countReadNotifications(barId ?? ''))
          .pipe(
            map((count) => Action.loadCountReadNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountReadNotificationsFailure({ error })))
          )
        )
      );
  });

  countUnreadNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountUnreadNotifications),
        mergeMap((action) => from(this.notificationService.countUnreadNotifications(action.barId))
          .pipe(
            map((count) => Action.loadCountUnreadNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountUnreadNotificationsFailure({ error })))
          )
        )
      );
  });

  countUnreadNotificationsFromCurrentBarId$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountUnreadNotificationsFromCurrentBarId),
        withLatestFrom(this.store.select(fromBar.selectBarId)),
        mergeMap(([action, barId]) => from(this.notificationService.countUnreadNotifications(barId ?? ''))
          .pipe(
            map((count) => Action.loadCountUnreadNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountUnreadNotificationsFailure({ error })))
          )
        )
      );
  });


  countUnreadBeverageNotificationsFromCurrentBarId$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountUnreadBeverageNotificationsFromCurrentBarId),
        withLatestFrom(this.store.select(fromBar.selectBarId)),
        mergeMap(([action, barId]) => from(this.notificationService.countUnreadBeverageNotifications(barId ?? ''))
          .pipe(
            map((count) => Action.loadCountUnreadBeverageNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountUnreadBeverageNotificationsFailure({ error })))
          )
        )
      );
  });
  //#endregion Count Notifications


  //#region Count Tap Notifications
  countAllTapNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountAllTapNotifications),
        mergeMap((action) => from(this.notificationService.countAllTapNotifications(action.barId))
          .pipe(
            map((count) => Action.loadCountAllTapNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountAllTapNotificationsFailure({ error })))
          )
        )
      );
  });

  loadCountAllTapNotificationsFromCurrentBarId$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountAllTapNotificationsFromCurrentBarId),
        withLatestFrom(this.store.select(fromBar.selectBarId)),
        mergeMap(([action, barId]) => from(this.notificationService.countAllTapNotifications(barId ?? ''))
          .pipe(
            map((count) => Action.loadCountAllTapNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountAllTapNotificationsFailure({ error })))
          )
        )
      );
  });

  countReadTapNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountReadTapNotifications),
        mergeMap((action) => from(this.notificationService.countReadTapNotifications(action.barId))
          .pipe(
            map((count) => Action.loadCountReadTapNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountReadTapNotificationsFailure({ error })))
          )
        )
      );
  });

  countReadTapNotificationsFromCurrentBarId$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountReadTapNotificationsFromCurrentBarId),
        withLatestFrom(this.store.select(fromBar.selectBarId)),
        mergeMap(([action, barId]) => from(this.notificationService.countReadTapNotifications(barId ?? ''))
          .pipe(
            map((count) => Action.loadCountReadTapNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountReadTapNotificationsFailure({ error })))
          )
        )
      );
  });

  countUnreadTapNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountUnreadTapNotifications),
        mergeMap((action) => from(this.notificationService.countUnreadTapNotifications(action.barId))
          .pipe(
            map((count) => Action.loadCountUnreadTapNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountUnreadTapNotificationsFailure({ error })))
          )
        )
      );
  });

  countUnreadTapNotificationsFromCurrentBarId$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadCountUnreadTapNotificationsFromCurrentBarId),
        withLatestFrom(this.store.select(fromBar.selectBarId)),
        mergeMap(([action, barId]) => from(this.notificationService.countUnreadTapNotifications(barId ?? ''))
          .pipe(
            map((count) => Action.loadCountUnreadTapNotificationsSuccess({ count })),
            catchError(error => of(Action.loadCountUnreadTapNotificationsFailure({ error })))
          )
        )
      );
  });
  //#endregion Count Tap Notifications



  //#region Cleanup Notifications
  markAllAsRead$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.markAllAsRead),
        mergeMap((action) => from(this.notificationService.markAllAsRead(action.barId))
          .pipe(
            map(() => {
              //this.toastService.saveSuccess();
              return Action.markAllAsReadSuccess();
            }),
            catchError(error => of(Action.markAllAsReadFailure({ error })))
          )
        )
      );
  });


  deleteAllReadNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.deleteAllReadNotifications),
        mergeMap((action) => from(this.notificationService.deleteAllReadNotifications(action.barId))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.deleteAllReadNotificationsSuccess();
            }),
            catchError(error => of(Action.deleteAllReadNotificationsFailure({ error })))
          )
        )
      );
  });

  deleteAllNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.deleteAllNotifications),
        mergeMap((action) => from(this.notificationService.deleteAllNotifications(action.barId))
          .pipe(
            map(() => {
              //              this.toastService.saveSuccess();
              return Action.deleteAllNotificationsSuccess();
            }),
            catchError(error => of(Action.deleteAllNotificationsFailure({ error })))
          )
        )
      );
  });
  //#endregion Cleanup Notifications



  //#region Cleanup TAP Notifications

  markAllTapAsRead$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.markAllTapAsRead),
        mergeMap((action) => from(this.notificationService.markAllTapAsRead(action.barId))
          .pipe(
            map(() => {
              //this.toastService.saveSuccess();
              return Action.markAllTapAsReadSuccess();
            }),
            catchError(error => of(Action.markAllTapAsReadFailure({ error })))
          )
        )
      );
  });

  deleteAllReadTapNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.deleteAllReadTapNotifications),
        mergeMap((action) => from(this.notificationService.deleteAllReadTapNotifications(action.barId))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.deleteAllReadTapNotificationsSuccess();
            }),
            catchError(error => of(Action.deleteAllReadTapNotificationsFailure({ error })))
          )
        )
      );
  });


  deleteAllTapNotifications$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.deleteAllTapNotifications),
        mergeMap((action) => from(this.notificationService.deleteAllTapNotifications(action.barId))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.deleteAllTapNotificationsSuccess();
            }),
            catchError(error => of(Action.deleteAllTapNotificationsFailure({ error })))
          )
        )
      );
  });

  //#endregion Cleanup TAP Notifications


  notificationsSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(
          Action.loadItemsSuccess,
          Action.deleteAllReadTapNotificationsSuccess,
          Action.deleteAllTapNotificationsSuccess,

          Action.deleteAllReadNotificationsSuccess,
          Action.deleteAllNotificationsSuccess,
          Action.loadUnreadItemsSuccess,

          Action.markAllAsReadSuccess,
          Action.markAllTapAsReadSuccess,
          Action.deleteItemSuccess,
        ),
        mergeMap(() => [
          Action.loadCountReadNotificationsFromCurrentBarId(),
          Action.loadCountUnreadNotificationsFromCurrentBarId(),

          Action.loadCountReadTapNotificationsFromCurrentBarId(),
          Action.loadCountUnreadTapNotificationsFromCurrentBarId(),
        ])
      );
  });






  add$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.addItem),
        mergeMap((action) => from(this.notificationService.add(action.item, action.id))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.addItemSuccess({ item: action.item });
            }),
            catchError(error => of(Action.addItemFailure({ error })))
          )
        )
      );
  });


  delete$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.deleteItem),
        mergeMap((action) => from(this.notificationService.delete(action.id))
          .pipe(
            map(() => {
              this.toastService.deleteItemSuccess();
              return Action.deleteItemSuccess({ id: action.id, route: action.route });
            }),
            catchError(error => of(Action.deleteItemFailure({ error })))
          )
        )
      );
  });

  deleteSuccess$ = createEffect(
    () => {
      return this.actions$
        .pipe(
          ofType(Action.deleteItemSuccess),
          tap((action) => {
            this.router.navigate([action.route]);
          }),
        )
    },
    { dispatch: false }
  );


  setRead$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.setRead),
        mergeMap((action) => from(this.notificationService.markAsRead(action.id))
          .pipe(
            mergeMap(() => [
              Action.setReadSuccess({ id: action.id }),
              Action.loadCountReadNotificationsFromCurrentBarId(),
              Action.loadCountUnreadNotificationsFromCurrentBarId()
            ]),
            catchError((error) => {
              return of(Action.setReadFailure({ error }))
            })
          )
        )
      );
  });

  softUpdate$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.softUpdate),
        mergeMap((action) => from(this.notificationService.softUpdate(action.id, action.data, action.uid))
          .pipe(
            map(() => {
              return Action.softUpdateSuccess({ id: action.id, data: action.data })
            }),
            catchError((error) => {
              return of(Action.softUpdateFailure({ error }))
            })
          )
        )
      );
  });

  softUpdateSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.softUpdateSuccess),
        tap(() => {
          this.toastService.saveSuccess();
        }),
      );
  }, { dispatch: false });


  softUpdateFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.softUpdateFailure),
        tap(({ error }) => {
          this.toastService.error(JSON.stringify(error));
        })
      );
  }, { dispatch: false });



}
